import script from "./StakingPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./StakingPopup.vue?vue&type=script&setup=true&lang=js"

import "./StakingPopup.vue?vue&type=style&index=0&id=35446016&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35446016"]])

export default __exports__